import { axiosClient } from "./axiosClient";

const packageApis = {
  getAllPackageUser: () => axiosClient.get(`/api/package/`),
  getAllPackage: () => axiosClient.get(`/api/package/get-all-package`),
  upgradePackage: (params: any) => axiosClient.put(`/api/package/upgrade-package`, { ...params }),
};

export default packageApis;
